<template>
  <div id="scenarios-view ">
    <error-boundary>

    <scenario-edit
              :data="selectedData"
              :blockModelId="blockModelId"
              :isSidebarActive="displayEditMode"
              @closeSidebar="toggleDataSidebar"
              @onSavedScenario="scenarioSaved"
            ></scenario-edit>

        <div class="vx-row">
         <div class="vx-col w-full mb-base">
          <vx-card :title="$t('GeoScenarioPage.ScenarioList')" title-color="black">
            <scenario-list
              @onScenarioSelected="selectedScenario"
              @onEditScenario="editScenario"
              @onCreateScenario="createScenario"
            ></scenario-list>
          </vx-card>
          </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full mb-base">
          <vx-card
            v-show="isSelectedModel"
            ref="nsrCard"
            :title="$t('GeoScenarioPage.NSRResults')"
            refresh-content-action
            @refresh="queryNSR"
            title-color="black"
          >
            <NSRResultsGrid
              ref="nsrResults"
              :scenarioId="scenarioId"
              @onNSRRefreshedSelected="nsrRefreshed"
            ></NSRResultsGrid>
          </vx-card>
        </div>
      </div>
    </error-boundary>
  </div>
</template>
<script>
import ScenarioList from "./components/scenarioList";
import ScenarioEdit from "./components/scenarioEdit";
import NSRResultsGrid from "./components/NSRResultsGrid";
import { ErrorBoundary } from "../../shared/components";

export default {
  components: {
    ErrorBoundary,
    ScenarioList,
    ScenarioEdit,
    NSRResultsGrid
  },
  data() {
    return {
      selectedData: {},
      blockModelId: null,
      scenarioId: null,
      displayEditMode: false
    };
  },
  computed: {
    isSelectedModel() {
      return Object.entries(this.selectedData).length !== 0;
    }
  },
  methods: {
    queryNSR() {
      this.$refs.nsrResults.queryNSR();
    },
    selectedScenario(data) {
      this.selectedData = data;
      this.scenarioId = data.id;
    },
    editScenario(data) {
      this.displayEditMode = true;
      this.selectedScenario(data);
    },
    scenarioSaved() {
      this.$vs.notify({
        title: this.$t("Success"),
        text: this.$t("SaveSuccess"),
        color: "success",
        iconPack: 'feather',
        icon:'icon-check'
      });
      this.displayEditMode = false;
    },
    createScenario(blockModelId) {
      this.displayEditMode = true;
      this.blockModelId = blockModelId;
      this.selectedData = {};
      this.scenarioId = null;
    },
    nsrRefreshed() {
      this.$refs.nsrCard.removeRefreshAnimation(300);
    },
    toggleDataSidebar(val = false) {
      this.displayEditMode = val;
    }
  }
};
</script>
<style lang="scss">
</style>